export default "__VITE_ASSET__B5y64uu___"